import React, { useEffect } from 'react';
import closebtn from '../assets/icons/closebtn.png';
import '../css/modal.css';
import { _formatPrice } from '../function/functions';

export const MembershipModal = ({ data, textData, modal, setModal }) => {
	const reverseData = data;

	useEffect(() => {
		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'unset';
		};
	}, []);

	return (
		<div className='MembershipModal'>
			<div className='member_container'>
				<div className='mem_modal_header'>
					<h1>{textData.mypage2.MEMBERSHIPSTANDARD}</h1>
					<img
						src={closebtn}
						onClick={() => {
							setModal(false);
						}}
					/>
				</div>
				{reverseData
					.map(item => {
						return (
							<div
								key={item.grade}
								className='membership_level_list'
							>
								<div className='membership_level_left'>
									<img src={item.img} />
									<h1>{item.level.toUpperCase()}</h1>
								</div>
								<div className='membership_level_right'>
									<h3>{_formatPrice(item.kct)} KCT</h3>
									<p>({_formatPrice(item.usdt)} USDT)</p>
								</div>
							</div>
						);
					})
					.reverse()}
			</div>
		</div>
	);
};
